export default {"src":"/uk/_next/static/media/planning-icon-grey.04e8262b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};